import React from 'react'
import createIcon from '@/lib/create-icon'

export const SendSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6673 1.33334L7.33398 8.66668M14.6673 1.33334L10.0007 14.6667L7.33398 8.66668M14.6673 1.33334L1.33398 6.00001L7.33398 8.66668" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,

)
